export default "__VITE_ASSET__Col9$qcJ__"